import Payment from "../../assets/icons/payment.svg";
import { Card } from "antd";
import { Link } from "react-router-dom";
import Button from "./button";
import { colors } from "../../share/constants/enums";
import MasterCard from "./masterCard";
import VisaCard from "./visaCard";
import { getExpressAccount } from "../../api/auth";

const ProfilePaymentMethod = ({ primaryLast4, count, primaryBrand }) => {
  const navigateToExpressAccount = async () => {
    try {
      const res = await getExpressAccount();
      if (res?.url) {
        window.open(res?.url, "_blank");
      } else {
        console.error("No link found in the response.");
      }
    } catch (error) {
      console.error("Error navigating to Express Account:", error);
    }
  };

  return (
    <Card className="border-2 shadow-md border-gray-200 h-screen sm:w-54.1 xl:w-54.1 sm:h-25.4">
      <div className="flex sm:justify-start justify-center ml-2">
        <img src={Payment} alt="Payment Icon" className="mr-1" />
        <p className="font-bold text-primaryOrange">Payment Method</p>
      </div>
      <div className="flex flex-col space-y-2 px-2 sm:px-0 sm:grid sm:grid-cols-2 sm:gap-2 sm:space-y-0">
        <div className="flex sm:ml-1 flex-col  sm:items-start items-center">
          <p className="font-medium text-primaryPurple text-lg mb-0">
            Primary Card
          </p>
          {primaryBrand === "visa" ? (
            <VisaCard last4={primaryLast4} />
          ) : (
            <MasterCard last4={primaryLast4} />
          )}
        </div>
        <div className={`flex flex-col sm:mr-1.5 sm:items-start items-center `}>
          <p className="font-medium text-primaryPurple text-lg mb-0">Cards</p>

          <Link to="/main/profile/payment-method" className="w-full">
            <Card className="bg-visaSecondary border-2 w-full h-8.7 flex items-center justify-center ">
              <p className="text-white font-medium ml-1">
                {count} Cards Attached
              </p>
            </Card>
          </Link>
        </div>
      </div>
      <div className="font-medium ml-2 mt-2 mb-0">
        <p onClick={navigateToExpressAccount}>
          Login to your <u className="cursor-pointer">Stripe Express Account</u>
        </p>
      </div>
      <div className="flex sm:absolute bottom-0 sm:right-0 justify-center p-2">
        <Link to="/main/profile/payment-method">
          <Button
            title="Manage"
            className="w-10 !h-3 !rounded-sm"
            color={colors.primaryPurple}
          />
        </Link>
      </div>
    </Card>
  );
};

export default ProfilePaymentMethod;
